module.exports = __webpack_public_path__ + "static/media/aws-card-icon.ae527159.png";